import React from 'react';
import { Row, RowChild } from 'styles';
import { priorityTypes, isLow, isHighError } from 'domain/notifications';
import { Notification, ButtonLinkColor } from 'components/notification';
import { Circle, ParentContainer, StyledIcon } from './notification-row.style';

interface Props {
  notification: QueriedNotification;
  hideTopBorder: boolean;
  isSMB: boolean;
}

export const NotificationRow = ({
  notification,
  hideTopBorder,
  isSMB,
}: Props) => {
  const { priorityType, utilityAccountDetails } = notification;
  const { accountNumber, displayServiceAddress, utilityDisplayName } =
    utilityAccountDetails || {};
  const shouldShowSubtitle: boolean =
    isSMB &&
    (!!accountNumber || !!displayServiceAddress || !!utilityDisplayName);
  const getIcon = () => {
    switch (priorityType) {
      case priorityTypes.highError:
        return (
          <StyledIcon color="errorBright" scale={2} data-testid="error-icon" />
        );
      case priorityTypes.highNonError:
        return <StyledIcon scale={2} data-testid="non-error-icon" />;
      default:
        return <Circle data-testid="circle" />;
    }
  };

  const buttonLinkProps = isLow(priorityType)
    ? { backgroundless: true, color: 'primary' as ButtonLinkColor }
    : undefined;

  const titleProps = isHighError(priorityType)
    ? { color: 'error' as const }
    : undefined;

  return (
    <Row hideTopBorder={hideTopBorder}>
      <RowChild
        padding="32px 24px 24px 48px"
        small={{ padding: '32px 24px 32px 40px' }}
      >
        <ParentContainer>
          <div>{getIcon()}</div>
          <Notification
            notification={notification}
            buttonLinkProps={buttonLinkProps}
            titleProps={titleProps}
            messageProps={{ textStyle: 'paragraph400' }}
            shouldShowSubtitle={shouldShowSubtitle}
          />
        </ParentContainer>
      </RowChild>
    </Row>
  );
};
